export enum AuthSessionStatus {
  Unknown = 'Unknown',
  Loading = 'Loading',
  NotRequired = 'NotRequired',
  Challenged = 'Challenged',
  Redirection = 'Redirection',
  SignedIn = 'SignedIn',
}

export enum AuthSessionEvent {
  Redirected = 'Redirected',
  SignedIn = 'SignedIn',
}

export interface IAuthSessionOptions {
  headers: { [key: string]: string };
}

export interface IAuthSessionState {
  status: AuthSessionStatus;
  event?: AuthSessionEvent;
  options?: IAuthSessionOptions;
}
